export default "__VITE_ASSET__CuxU1dEo__"